import { render, staticRenderFns } from "./activityTitle.vue?vue&type=template&id=36d48b1b&scoped=true&"
import script from "./activityTitle.vue?vue&type=script&lang=js&"
export * from "./activityTitle.vue?vue&type=script&lang=js&"
import style0 from "./activityTitle.vue?vue&type=style&index=0&id=36d48b1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d48b1b",
  null
  
)

export default component.exports